import { Jsonp, Http } from "@angular/http";
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { List } from "linqts";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { LocalStorage } from "../core/helper/localStorage";
import { BaseComponent } from "../core/component/Base.Component";
import { AppConstants } from "../app.constant";
import { InstituteService } from "../shell/forms/organizational-setup/setup/institute/institute.service";
import { SystemPolicyService } from "../shell/forms/organizational-setup/setup/systempolicy/systempolicy.service";
import { ImageService } from "../shell/shared/image.service";
import { GenEnum } from "../shell/shared/general.enum";
import { EmployeeinfohdrService } from "../shell/forms/Employee-Profile/Employeeinfohdr/employee-profile/employee-profile.service";
import { IxsloaderComponent } from "../components/ixsloader/ixsloader.component";
import { ConstantClass } from "../login/login.component";
import { Observable } from "rxjs";
import { ErrorComponent } from "../components/error/error.component";
import { errorArgs } from "../components/error/error.config";

@Component({
  templateUrl: "userclients.component.html"
})
export class UserClientsComponent extends BaseComponent {
  userurl: any;
  category: any;
  email: any;
  name: any;
  imageSource: any;
  url: string;
  model: any = {};
  userclients: any;
  localStorage: LocalStorage;
  selectedEntity;

  @ViewChild("error") errorForm: ErrorComponent;

  @ViewChild(IxsloaderComponent) loader: IxsloaderComponent;
  @ViewChild("image") image: ElementRef;

  constructor(
    private instituteService: InstituteService,
    private SystemPolicyservice: SystemPolicyService,
    private _employee: EmployeeinfohdrService,
    private _GNImage: ImageService,
    private http: Http
  ) {
    super();

    if (
      this.localStorage !== undefined &&
      this.localStorage.get("setselectedEntity")
    )
      this.localStorage.remove("setselectedEntity");

    if (!this.localStorage.get("token")) this.navigate("login");

    this.localStorage = AppConstants.injector.get(LocalStorage);
    this.imageSource =
      AppConstants.urls.api.base.replace("api/", "") + GenEnum.Image.imageUrl;

    this.getData().subscribe((i: ConstantClass) => {
      if (
        i.Clients.length > 0 &&
        i.Clients.filter(o => o.hostname === window.location.hostname)[0]
      )
        if (this.image && this.image.nativeElement) {
          this.image.nativeElement.src =
            AppConstants.urls.api.base.replace("api/", "") +
            GenEnum.Image.imageUrl +
            i.Clients.filter(o => o.hostname === window.location.hostname)[0]
              .filename;
        }

    });
  }

  getData(): Observable<ConstantClass> {
    return this.http.get("../../assets/IXS/resultJSON.json").map(res => {
      return <ConstantClass>res.json();
    });
  }

  async ngOnInit() {
    this.model.fullname = localStorage.getItem("Fullname").toUpperCase();
    this.model.username = localStorage.getItem("User").toUpperCase();
    this.model.clientstxt = localStorage.getItem("ClientStxt").toUpperCase();
    this.model.clientcode = localStorage.getItem("ClientCode").toUpperCase();
    this.model.userclients = localStorage.getItem("userclients");

    await this.getEntity();
    await this.getclientimage();
    if (this.LookupData.instituteList && this.LookupData.instituteList.length === 1) {
      this.model.selectedEntity = this.LookupData.instituteList[0].Id;
      this.setselectedEntity(this.model.selectedEntity);
      this.checkentityExist();
    }
  }

  async setselectedEntity(selectedEntity) {
    var data = this.LookupData.instituteList.filter(
      o => o.Id === selectedEntity
    )[0];
    if (data) this.localStorage.set("ClientStxt", data.stxt);

    if (this.localStorage.get("setselectedEntity"))
      this.localStorage.remove("setselectedEntity");

    this.localStorage.set("selectedEntity", selectedEntity);
  }

  async checkentityExist() {

    var entityid = this.localStorage.get("selectedEntity");
    if (entityid) {
      let rslt = await this.getPolicy(entityid);

      if (rslt && rslt.IsSuccess) {
        this.loader.startLoading();
        var dto = await this.instituteService.get(entityid);

        if (dto && dto.IsSuccess) {
          this.loader.stopLoading();
          const legalEntity = dto.Data;

          if (legalEntity) {
            this.localStorage.set("ShortName", legalEntity.shortname);
            this.loader.startLoading();
            var dtoImage = await this._GNImage.get(legalEntity.imageid);

            if (dtoImage && dtoImage.IsSuccess) {
              this.loader.stopLoading();
              const gnimage = dtoImage.Data;

              if (gnimage && gnimage.filename) {
                this.LookupData.imageSource =
                  this.localStorage.get("OnlyUrl") +
                  GenEnum.Image.imageUrl +
                  gnimage.filename;

                this.localStorage.set("EntityLogo", this.LookupData.imageSource);
              } else console.log("logo image not found");
            } else {
              this.loader.stopLoading();
            }
          } else
            console.log("Entity Data does not exist, entityid : " + entityid);

          let utuser = JSON.parse(this.localStorage.get("utuser"));

          if (utuser) {
            if (utuser.usercatid == GenEnum.User_Category.Admin) {
            }

            if (utuser.usercatid == GenEnum.User_Category.Driver) {
            }

            if (utuser.usercatid == GenEnum.User_Category.Employee || utuser.usercatid == GenEnum.User_Category.Admin) {
              let referenceid = utuser.empid;
              if (referenceid) {
                this.loader.startLoading();
                const loginemployee = await this._employee.getLoginUserInfo(
                  referenceid
                );

                if (loginemployee && loginemployee.Data) {
                  this.loader.stopLoading();
                  this.localStorage.set(
                    "LoginUserInfo",
                    JSON.stringify(loginemployee.Data)
                  );
                  if (this.userurl) {
                    this.localStorage.set(
                      "userpic",
                      this.userurl
                    );
                  }
                } else {
                  this.loader.stopLoading();
                  console.log("Employee does not exists, id = " + referenceid);
                }
              } else {
                console.log("Employee not define on user");
                this.errorForm.showErrors("Employee not define on user");
                return;
              }
            }
          }

          const result = await this.instituteService.getOrganizationStatus();

          if (result && result.IsSuccess && result.Data) {


          } else {

            var errors = [];
            if (result && result.Errors) {
              result.Errors.forEach(element => {
                errors.push(element.Description);
              });

              this.errorForm.showErrors(errors, "Information", 1, 2);
              this.navigate("login");
              return;
            }
          }

          this.navigate("home");
        } else {
          this.loader.stopLoading();
          this.errorForm.showErrors(
            dto.Errors.length > 0 ? dto.Errors : "Invalid user school"
          );
          //this.navigate("login");
        }

      } else {
        this.showErrors(rslt.Errors);
      }
    } else {
      console.log("Entity id does not exists, id = " + entityid);
      this.navigate("login");
    }
  }

  async getPolicy(entityid: any) {
    this.loader.startLoading();
    const dto = await this.SystemPolicyservice.getPolicy(entityid);
    if (dto && dto.IsSuccess && dto.Data) {
      AppConstants.policy.dateFormat = dto.Data.dateformat;
      AppConstants.policy.timeFormat = dto.Data.timeformat;
      AppConstants.policy.gridpagging = dto.Data.gridpagging;
      AppConstants.policy.defaultctryid = dto.Data.defaultctryid;
      AppConstants.policy.defaultcityid = dto.Data.defaultcityid;
      this.loader.stopLoading();
    } else {
      this.loader.stopLoading();
      this.errorForm.showErrors(dto.Errors);
    }
    return dto;
  }

  async getEntity() {
    var entitydata;
    var utuserents = JSON.parse(localStorage.getItem("utuserents"));

    if (utuserents && utuserents !== null) {
      var entities = [];
      utuserents.forEach(element => {
        entities.push(element.entityid);
      });

      if (entities && entities.length > 0)
        this.loader.startLoading();
      entitydata = await this.instituteService.GetUserEntityData(entities)
      if (entitydata && entitydata.IsSuccess) {
        this.LookupData.instituteList = entitydata.Data;
        this.loader.stopLoading();
      }
      else {
        this.loader.stopLoading();
      }
    }



  }

  async getclientimage() {
    let UserInfo = JSON.parse(this.localStorage.get("utuser"));

    if (UserInfo) {
      this.name = UserInfo.fullname;
      this.email = UserInfo.emailid;
      this.category = UserInfo.lov1 === undefined || UserInfo.lov1.ltxt === "" ? "-" : UserInfo.lov1.ltxt;
      this.userurl = UserInfo.GNImage !== undefined ? this.imageSource + UserInfo.GNImage.filename : this.imageSource;
    }
  }

  confirm(value: errorArgs) {
    if (value.value === 1 && value.type === GenEnum.ErrorTypes.Error) {
      this.navigate("login");
    }
  }

  // async getOrganizationStatus() {

  // }


  greetings(){
  const time = new Date().getHours();
  let greeting;
  if (time < 12) {
  greeting = "Good morning";
  } else if (time < 15) {
   greeting = "Good afternoon";
  } else {
   greeting = "Good evening";
  }
  document.getElementById("demo").innerHTML = greeting; 
 
  }
}



// WEBPACK FOOTER //
// ./src/app/userclients/userclients.component.ts